import React from 'react';
import { ContactSection } from '../components/ContactSection';
import { getContent } from '../utils/contentStore';
import { useSEO } from '../utils/useSEO';
import { useLanguage } from '../utils/i18n';
export function ContactPage() {
  useSEO('contact');
  const map = getContent().map;
  const {
    t,
    loc
  } = useLanguage();
  const mapSrc = `https://yandex.ru/map-widget/v1/?ll=${map.lng}%2C${map.lat}&z=${map.zoom}&pt=${map.lng}%2C${map.lat}%2Cpm2rdm`;
  return <div className="pt-20 bg-gray-50 min-h-screen" data-id="element-1021">
      <div className="container mx-auto px-4 py-12 text-center" data-id="element-1022">
        <h1 className="font-heading text-4xl md:text-6xl font-bold text-gray-900 uppercase mb-4 leading-tight" data-id="element-1023">
          {t('contact_page_title_1')}{' '}
          <span className="text-red-600" data-id="element-1024">{t('contact_page_title_2')}</span>
        </h1>
        <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-1025">
          {t('contact_page_desc')}
        </p>
      </div>
      <ContactSection data-id="element-1026" />

      <div className="h-[400px] w-full bg-gray-200 relative" data-id="element-1027">
        <iframe src={mapSrc} width="100%" height="100%" frameBorder="0" title="Yavuz Burak Location" className="grayscale hover:grayscale-0 transition-all duration-500" data-id="element-1028" />

        <div className="absolute bottom-4 left-1/2 -translate-x-1/2 bg-white px-6 py-3 rounded-full shadow-lg text-sm font-bold text-gray-900 whitespace-nowrap" data-id="element-1029">
          {loc(map.addressLabel)}
        </div>
      </div>
    </div>;
}